module.exports = __webpack_public_path__ + "static/media/photo28.be28f05f.jpg";